module.exports = __webpack_public_path__ + "static/media/frontLoadContainerWithCasters.f0318cb7.png";